export function getErrorText(error) {
    try{
        return JSON.stringify(error?.join(", "));
    }
    catch(e) {
        return error;
    }
}
